module.exports = __webpack_public_path__ + "static/media/no-records.2d8a3daa.png";